import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import styles from "./LoaderButton.module.css";

const LoaderButton = ({
  isProcessing,
  onClick,
  confirmText = "Confirm",
  borderRadius = "50px",
  width = "240px",
}) => {
  return (
    <>
      {isProcessing ? (
        <Box 
        className={styles.loadingContainer}
        sx={{
            borderRadius: borderRadius,
            width: width,
            }}
        >
          <CircularProgress size={24} className={styles.loaderSpinner} />
          <Typography className={styles.processingText}>Processing...</Typography>
        </Box>
      ) : (
        <Button
          variant="contained"
          onClick={onClick}
          className={styles.confirmButton}
          sx={{
            borderRadius: borderRadius,
            width: width,
          }}
        >
          {confirmText}
        </Button>
      )}
    </>
  );
};

export default LoaderButton;